export const contactsData = {
    email: 'mrutyunjaya.sahoo107@gmail.com',
    phone: '+918114793923',
    address: 'Bhubaneswar, Odisha, India',

    sheetAPI: 'https://sheetdb.io/api/v1/jzo3l4ebv6mn1'
}